<mtc-dialog-template [config]="dialogTemplateConfig">
	<div class="confirmation-content">
		<span class="body-text" [innerHTML]="dataInput.content"></span>
	</div>
</mtc-dialog-template>
